// Publisher details, in one place because they appear in every legal document.
//
// Sourced from the Wyoming Articles of Organization (filed 2026-05-06, original
// ID 2026-001970517). The registered agent, mailing and principal office
// addresses on that filing are all the same Registered Agents Inc address, so
// that is the entity's address of record.
//
// ANY REMAINING [[TOKEN]] MUST BE REPLACED BEFORE THESE PAGES GO LIVE — they
// render highlighted so they cannot ship unnoticed. A privacy notice that fails
// to identify its controller or give a working contact route is defective under
// Mexico's LFPDPPP Art. 15 and CPRA's notice-at-collection rule alike.
export const entity = {
  legalName: 'Tribys LLC',
  tradingName: 'Tribys',
  formedIn: 'Wyoming',
  address: '30 N Gould St, Ste R, Sheridan, WY 82801',
  // All four are Google Workspace aliases on tribys.com, and every one MUST exist
  // and deliver before these pages go live. Each carries a statutory clock that
  // starts whether or not the mail arrived: 20 business days for ARCO, 45 days for
  // US state privacy requests, 60 days for the Terms' informal dispute resolution.
  privacyEmail: 'privacy@tribys.com',
  // Safety reports, moderation appeals and general support — deliberately NOT the
  // legal channel. Appeals are high-volume operational work and would bury the
  // formal notices that have deadlines attached.
  supportEmail: 'support@tribys.com',
  // Formal legal channel: Notices of Dispute, arbitration opt-outs, and notices
  // under the Terms. Kept separate from support@ so a pre-litigation notice cannot
  // be lost in a moderation queue.
  legalEmail: 'legal@tribys.com',
  // The DMCA designated agent address. Publishing it here is necessary but not
  // sufficient — DMCA 512(c) safe harbour also requires the agent to be
  // registered with the US Copyright Office, and that registration lapses after
  // three years if it is not renewed. Without it there is no safe harbour, no
  // matter what this document says.
  copyrightEmail: 'copyright@tribys.com',
  // Quebec Law 25 requires publishing the title and contact details of the person
  // accountable for personal information. Published as a role rather than a named
  // individual, which satisfies it and survives the role changing hands.
  privacyOfficer: 'Privacy Officer',
  effectiveDate: '2026-07-28',
} as const;

export const legalPaths = {
  privacy: '/privacy',
  privacyEs: '/es/privacy',
  biometric: '/biometric-notice',
  biometricEs: '/es/biometric-notice',
  terms: '/terms',
  termsEs: '/es/terms',
  guidelines: '/community-guidelines',
  guidelinesEs: '/es/community-guidelines',
} as const;
